var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery-note-index-page po main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("deliveryNotes.title"))),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                {
                  attrs: { slot: "item-title", to: "dashboard" },
                  slot: "item-title",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("general.home")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                { attrs: { slot: "item-title", to: "#" }, slot: "item-title" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$tc("deliveryNotes.delivery_note", 2)) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showFilters,
                expression: "showFilters",
              },
            ],
            staticClass: "filter-section",
          },
          [
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "div",
                { staticClass: "filter-customer" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$tc("customers.customer", 1)) + " "),
                  ]),
                  _vm._v(" "),
                  _c("base-select", {
                    attrs: {
                      options: _vm.customers,
                      searchable: true,
                      "show-labels": false,
                      "allow-empty": true,
                      tabindex: 8,
                      placeholder: _vm.$t("customers.type_or_click"),
                      label: "name",
                      "track-by": "id",
                    },
                    model: {
                      value: _vm.filters.customer,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "customer", $$v)
                      },
                      expression: "filters.customer",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-status" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("deliveryNotes.status")))]),
                  _vm._v(" "),
                  _c("base-select", {
                    attrs: {
                      options: _vm.status,
                      searchable: true,
                      "show-labels": false,
                      placeholder: _vm.$t("general.select_a_status"),
                    },
                    on: {
                      remove: function ($event) {
                        return _vm.clearStatusSearch()
                      },
                    },
                    model: {
                      value: _vm.filters.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "status", $$v)
                      },
                      expression: "filters.status",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "filter-date" }, [
                _c(
                  "div",
                  { staticClass: "from pr-3" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("general.from")))]),
                    _vm._v(" "),
                    _c("base-date-picker", {
                      attrs: {
                        "calendar-button": true,
                        "calendar-button-icon": "calendar",
                      },
                      model: {
                        value: _vm.filters.from_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "from_date", $$v)
                        },
                        expression: "filters.from_date",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dashed" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "to pl-3" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("general.to")))]),
                    _vm._v(" "),
                    _c("base-date-picker", {
                      attrs: {
                        "calendar-button": true,
                        "calendar-button-icon": "calendar",
                      },
                      model: {
                        value: _vm.filters.to_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "to_date", $$v)
                        },
                        expression: "filters.to_date",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-po" },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.$t("deliveryNotes.delivery_note_number"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("base-input", {
                    attrs: { icon: "hashtag" },
                    model: {
                      value: _vm.filters.delivery_note_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "delivery_note_number", $$v)
                      },
                      expression: "filters.delivery_note_number",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "clear-filter", on: { click: _vm.clearFilter } },
              [_vm._v(_vm._s(_vm.$t("general.clear_all")))]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEmptyScreen,
              expression: "showEmptyScreen",
            },
          ],
          staticClass: "col-xs-1 no-data-info",
          attrs: { align: "center" },
        },
        [
          _c("moon-walker-icon", { staticClass: "mt-5 mb-4" }),
          _vm._v(" "),
          _c("div", { staticClass: "row", attrs: { align: "center" } }, [
            _c("label", { staticClass: "col title" }, [
              _vm._v(_vm._s(_vm.$t("deliveryNotes.no_delivery_note"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "label",
              {
                staticClass: "description col mt-1",
                attrs: { align: "center" },
              },
              [_vm._v(_vm._s(_vm.$t("deliveryNotes.list_of_delivery_note")))]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showEmptyScreen,
              expression: "!showEmptyScreen",
            },
          ],
          staticClass: "table-container",
        },
        [
          _c(
            "div",
            { staticClass: "table-actions mt-5" },
            [
              _c("p", { staticClass: "table-stats" }, [
                _vm._v("\n        " + _vm._s(_vm.$t("general.showing")) + ": "),
                _c("b", [_vm._v(_vm._s(_vm.deliveryNotes.length))]),
                _vm._v("\n        " + _vm._s(_vm.$t("general.of")) + " "),
                _c("b", [_vm._v(_vm._s(_vm.totalDeliveryNotes))]),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "tabs" }, [
                _c(
                  "li",
                  {
                    staticClass: "tab",
                    on: {
                      click: function ($event) {
                        return _vm.getStatus("")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: [
                          "tab-link",
                          {
                            "a-active":
                              _vm.filters.status === "" ||
                              (_vm.filters.status !== "DRAFT" &&
                                _vm.filters.status !== "SENT" &&
                                _vm.filters.status !== "ACCEPTED" &&
                                _vm.filters.status !== "REJECTED" &&
                                _vm.filters.status !== "SETTLED"),
                          },
                        ],
                        attrs: { href: "#" },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.all")))]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.selectedDeliveryNotes.length
                    ? _c(
                        "v-dropdown",
                        { attrs: { "show-arrow": false } },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "table-actions-button dropdown-toggle",
                              attrs: { slot: "activator", href: "#" },
                              slot: "activator",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("general.actions")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-dropdown-item", [
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-item",
                                on: { click: _vm.removeMultipleDeliveryNotes },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "dropdown-item-icon",
                                  attrs: { icon: ["fas", "trash"] },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("general.delete")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "custom-control custom-checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectAllFieldStatus,
                  expression: "selectAllFieldStatus",
                },
              ],
              staticClass: "custom-control-input",
              attrs: {
                id: "select-all",
                disabled: _vm.deliveryNotes.length <= 0,
                type: "checkbox",
              },
              domProps: {
                checked: Array.isArray(_vm.selectAllFieldStatus)
                  ? _vm._i(_vm.selectAllFieldStatus, null) > -1
                  : _vm.selectAllFieldStatus,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.selectAllFieldStatus,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.selectAllFieldStatus = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.selectAllFieldStatus = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.selectAllFieldStatus = $$c
                    }
                  },
                  _vm.selectAllDeliveryNotes,
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isRequestOngoing,
                    expression: "!isRequestOngoing",
                  },
                ],
                staticClass: "custom-control-label selectall",
                attrs: { for: "select-all" },
              },
              [
                _c("span", { staticClass: "select-all-label" }, [
                  _vm._v(_vm._s(_vm.$t("general.select_all")) + " "),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "table-component",
            {
              ref: "table",
              attrs: {
                "show-filter": false,
                data: _vm.fetchData,
                "table-class": "table",
              },
            },
            [
              _c("table-column", {
                attrs: {
                  sortable: false,
                  filterable: false,
                  "cell-class": "no-click",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c(
                          "div",
                          { staticClass: "custom-control custom-checkbox" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectField,
                                  expression: "selectField",
                                },
                              ],
                              staticClass: "custom-control-input",
                              attrs: { id: row.id, type: "checkbox" },
                              domProps: {
                                value: row.id,
                                checked: Array.isArray(_vm.selectField)
                                  ? _vm._i(_vm.selectField, row.id) > -1
                                  : _vm.selectField,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selectField,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = row.id,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectField = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectField = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectField = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", {
                              staticClass: "custom-control-label",
                              attrs: { for: row.id },
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: {
                  label: _vm.$t("deliveryNotes.date"),
                  "sort-as": "delivery_note_date",
                  show: "formattedDeliveryNoteDate",
                },
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: {
                  label: _vm.$tc("pos.po_num"),
                  show: "purchase_order.reference_number",
                },
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: { label: _vm.$t("deliveryNotes.customer") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        row.buyer_stakeholder
                          ? _c("p", [
                              row.buyer_stakeholder.details.company &&
                              row.buyer_stakeholder.details.company.name
                                ? _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          row.buyer_stakeholder.details.company
                                            .name
                                        ) +
                                        "\n            "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: {
                  label: _vm.$tc("deliveryNotes.status"),
                  show: "status",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.$t("deliveryNotes.status"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            class:
                              "deliveryNote-status-" + row.status.toLowerCase(),
                          },
                          [_vm._v(_vm._s(row.status))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: {
                  sortable: false,
                  filterable: false,
                  "cell-class": "action-dropdown",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " + _vm._s(_vm.$t("deliveryNotes.action")) + " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-dropdown",
                          [
                            _c(
                              "a",
                              {
                                attrs: { slot: "activator", href: "#" },
                                slot: "activator",
                              },
                              [_c("dot-icon")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-dropdown-item",
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: {
                                      to: {
                                        path:
                                          "delivery-notes/" + row.id + "/view",
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "dropdown-item-icon",
                                      attrs: { icon: "eye" },
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("general.view")) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-dropdown-item", [
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadDeliveryNote(
                                        row.unique_hash
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "dropdown-item-icon",
                                    attrs: { icon: "download" },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("general.doawnload_excel")
                                      ) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            row.status == "DRAFT" &&
                            row.purchase_order.items &&
                            row.purchase_order.items.length > 0
                              ? _c(
                                  "v-dropdown-item",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          to: {
                                            path:
                                              "delivery-notes/" +
                                              row.id +
                                              "/edit",
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "dropdown-item-icon",
                                          attrs: {
                                            icon: ["fas", "pencil-alt"],
                                          },
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("general.edit")) +
                                            "\n              "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : row.status == "DRAFT"
                              ? _c(
                                  "v-dropdown-item",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          to: {
                                            path:
                                              "manually-delivery-notes/" +
                                              row.id +
                                              "/edit",
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "dropdown-item-icon",
                                          attrs: {
                                            icon: ["fas", "pencil-alt"],
                                          },
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("general.edit")) +
                                            "\n              "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            row.status == "DRAFT"
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeDeliveryNote(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["fas", "trash"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("general.delete")) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            row.status == "DRAFT" && row.items.length > 0
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.stableDeliveryNote(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: "check-circle" },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "deliveryNotes.mark_as_cofirmed"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            row.status == "CONFIRMED" ||
                            row.status == "PARTIALLY_SETTLED"
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.convertInToinvoice(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: "file-alt" },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("pos.convert_to_invoice")
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }